module.exports = __webpack_public_path__ + "6c478d9ec245ab2bf2cf0bbb58f93815.jpg";